import { useNavigate } from 'react-router-dom';

export default function FeaturesCTA() {
  const navigate = useNavigate();

  return (
    <section className="relative py-20 sm:py-28 lg:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/98b103711f2224541dcc151d388f2ecf.jpg"
          alt="Aerial cockpit view"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1628]/75 via-[#0A1628]/85 to-[#0A1628]"></div>
      </div>

      {/* HUD corners - scale down on mobile */}
      <div className="absolute top-4 sm:top-8 left-4 sm:left-8 w-8 h-8 sm:w-14 sm:h-14 border-l-2 border-t-2 border-[#00FFD1]/30"></div>
      <div className="absolute top-4 sm:top-8 right-4 sm:right-8 w-8 h-8 sm:w-14 sm:h-14 border-r-2 border-t-2 border-[#00FFD1]/30"></div>
      <div className="absolute bottom-4 sm:bottom-8 left-4 sm:left-8 w-8 h-8 sm:w-14 sm:h-14 border-l-2 border-b-2 border-[#00FFD1]/30"></div>
      <div className="absolute bottom-4 sm:bottom-8 right-4 sm:right-8 w-8 h-8 sm:w-14 sm:h-14 border-r-2 border-b-2 border-[#00FFD1]/30"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center relative z-10">
        <div className="inline-flex items-center gap-2 bg-[#00FFD1]/10 border border-[#00FFD1]/30 rounded-full px-4 sm:px-5 py-2 mb-6 sm:mb-8">
          <i className="ri-rocket-line text-[#00FFD1] text-sm"></i>
          <span className="text-[#00FFD1] text-xs sm:text-sm font-medium uppercase tracking-widest">Ready to fly smarter?</span>
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 leading-tight">
          Fly with a smarter<br />right seat.
        </h2>
        <p className="text-base sm:text-lg lg:text-xl text-gray-300 mb-8 sm:mb-12 leading-relaxed max-w-2xl mx-auto">
          Join pilots and instructors using WingmanFix to build safer, sharper flying habits — one flight at a time.
        </p>

        {/* Buttons stack vertically on mobile */}
        <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-5">
          <button className="bg-[#00A3E0] hover:bg-[#0088BB] text-white px-8 sm:px-10 py-3 sm:py-4 rounded-lg transition-all font-bold text-sm sm:text-base shadow-2xl hover:shadow-[#00A3E0]/40 hover:scale-105 cursor-pointer whitespace-nowrap">
            <i className="ri-download-line mr-2"></i>Download WingmanFix
          </button>
          <button
            onClick={() => navigate('/pricing')}
            className="bg-white/10 backdrop-blur-sm border-2 border-white/60 text-white hover:bg-white/20 px-8 sm:px-10 py-3 sm:py-4 rounded-lg transition-all font-bold text-sm sm:text-base cursor-pointer whitespace-nowrap"
          >
            <i className="ri-price-tag-3-line mr-2"></i>View Pricing
          </button>
        </div>

        <p className="mt-8 sm:mt-10 text-xs sm:text-sm text-gray-500 italic">Built by pilots, for pilots.</p>
      </div>
    </section>
  );
}